import { buildService } from './decorated-service';

const submissionTrackingAPI = buildService(
  '/new-account-svc/service/account/result'
);

export const submissionTrackingService = (
  trackingIdentifier: any
): Promise<any> => {
  return submissionTrackingAPI.add(trackingIdentifier);
};
